import * as React from 'react';
import { MobileStepbarMode } from './types';
export var MobileStepbarContext = React.createContext(MobileStepbarMode.Checkout);
var MobileStepbarContextProvider = MobileStepbarContext.Provider;
export default MobileStepbarContextProvider;
